export default class TagType {
  name: string
  parent_ids: number[]
  tag_ids: number[]
  id: number

  constructor(json: any) {
    this.id = json.id ?? 0
    this.name = json.name ?? ""
    this.parent_ids = json.parent_ids ?? <number[]>[]
    this.tag_ids = json.tag_ids ?? <number[]>[]
  }
}
